//noScroll
class HeaderNavEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    jQuery(function($){

      if (window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches) {
        $(window).on('scroll', function(){
          let point = window.pageYOffset;
          let dispHeight = $(".c-page-footer").offset().top;
          if(point + 100 > dispHeight ){
            $(".js-header").fadeOut(300)
          }else{
            $(".js-header").fadeIn(300)
          }
        });
      }
      else if (window.matchMedia('(min-width: 768px)').matches) {
        $(window).on('scroll', function(){
          let point = window.pageYOffset;
          let dispHeight = $(".c-page-footer").offset().top;
          if(point + 700 > dispHeight ){
            $(".js-headerNav").fadeOut(300)
            $(".l-header-sns").fadeOut(300)
          }else{
            $(".js-headerNav").fadeIn(300)
            $(".l-header-sns").fadeIn(300)
          }
        });
      }

      if (window.matchMedia('(max-width: 767px)').matches) {

        $(window).on('scroll', function(){
          let point = window.pageYOffset;
          let dispHeight = $(".c-page-footer").offset().top;
          if(point + 100 > dispHeight ){
            $(".js-header").fadeOut(300)
          }else{
            $(".js-header").fadeIn(300)
          }
        });
      }
    });

    jQuery(document).ready(function($) {

    });

    $(function(){
      if (window.matchMedia('(max-width: 850px)').matches) {
        const HeaderContainer = document.querySelector(".js-headerNav")
        const openNav = document.querySelectorAll(".l-header__click, .l-header__overlay")

        openNav.forEach(function(el) {
          el.addEventListener("click", () => {
            HeaderContainer.classList.toggle("is-open")
            document.querySelector(".l-header__bg-topParts").classList.toggle("is-wide")
            document.querySelector(".l-header__overlay").classList.toggle("is-open")
            document.querySelector("body").classList.toggle("is-open")
  
            if(HeaderContainer.classList.contains("is-open")){
              document.querySelector(".l-header__btnText.open").classList.remove("is-show")
              document.querySelector(".l-header__btnText.close").classList.add("is-show")
              setTimeout(() => {
                document.querySelector(".l-header__list").classList.add("is-show")
                document.querySelector(".l-header__link").classList.add("is-show")
              }, 500);
            }else{
              document.querySelector(".l-header__btnText.open").classList.add("is-show")
              document.querySelector(".l-header__btnText.close").classList.remove("is-show")
              document.querySelector(".l-header__list").classList.remove("is-show")
              document.querySelector(".l-header__link").classList.remove("is-show")
            }
          })
        })
      }
    })
  }
}
